export default __webpack_public_path__ + "static/media/ic_menu_timesheet_staff.6fb99026.svg";